import React, { useState, useRef } from "react"
import emailjs from "@emailjs/browser"
import { useNavigate } from "react-router-dom";
import "./ContactUs.css"



const Result = () => {
  return (
    
    <p className="result-msg">Our team will contact you shortly</p>
   
  );
};

const ContactUs = () => {

 
  const [result, showResult] = useState(false)

   const navigate = useNavigate();
 

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_k4aiwmr",
        "template_d5xkeq4",
        form.current,
        "Fh0Y9YM-DloiKhGif"
      )
      .then(
        (result) => {
          console.log(result.text);
       
        },
        (error) => {
          console.log(error.text);
        }
      );
      e.target.reset();
      showResult(true)

      navigate("/Thanks");
  };

  

  return (

    <div className="form-container">
    <h2 className="popform__heading"> <span style={{ color: "rgb(236, 101, 74)" }} >Get a info pack</span></h2>
    <h2 className="popform__offer"><span style={{ color: "whitesmoke" }} >*Submit your details <br/> for more info </span></h2>
     <form className="form-contact" ref={form} onSubmit={sendEmail}>
        <label>Name</label>
        <input className="input-contact" type="text" name="user_name" required />
        <label>Email</label>
        <input className="input-contact" type="email" name="user_email" required />
        <label>Mobile</label>
        <input className="input-contact" type="text" name="user_name" required />
        <label>Tell us about your property</label>
        <textarea className="input-contact" name="message" />
        <div> {result ? <Result/> : null}</div>
        <input  className="input-button  last_input" type="submit" value="Submit" />
      </form>
   
 </div>  
  );
};

export default ContactUs;